export enum VALIDATION_STATES {
    VALID = 'VALID',
    INVALID = 'INVALID',
    DISABLED = 'DISABLED',
    PENDING = 'PENDING',
}

export enum VALIDATION_CLASSES {
    IS_VALID = 'is-valid',
    IS_INVALID = 'is-invalid',
    INVALID_FEEDBACK = 'invalid-feedback',
    VALID_FEEDBACK = 'valid-feedback',
}

export enum VALIDATION_ERROR_MESSAGES {
    empty = '',
    default = 'ERROR_INVALID',
    forbiddenCharacters = 'ERROR_FORBIDDEN_CHARACTERS',
    required = 'ERROR_REQUIRED',
    maxlength = 'ERROR_MAXLENGTH_EXCEEDED',
    minlength = 'ERROR_MINLENGTH_NOT_REACHED',
    pattern = 'ERROR_PATTERN_NOT_MATCHED',
    maxLines = 'ERROR_MAX_LINES_EXCEEDED',
    numSelected = 'ERROR_SELECTION_INVALID',
}
